<template>
  <div class="jiaoxue">
    <!-- 肾内病例教学直播 -->
    <div class="header">
      <div class="title">
        <titleCard title="肾内病例教学直播"></titleCard>
      </div>
      <div class="head-img animate__animated wow animate__fadeIn">
        <div class="left">
          <h3>权威学术支持</h3>
          <p>中国研究型医院学会血液净化专业委员会</p>
        </div>
        <div class="right">
          <img src="../../assets/image/Science/jiaoxue/logo1.webp" alt="" />
        </div>
      </div>
      <div class="content">
        <div class="txtbox animate__animated wow animate__fadeInLeft">
          为了提升基层医疗机构肾内科医师对常见肾内科疾病的管理能力，促进肾内科相关学科知识的传播和分级诊疗的落地，由国家卫健委能力建设和继续教育中心主办，中国研究型医院学会血液净化专委会学术支持的
          “肾内病例教学直播”活动，邀请核心组长单位轮值主持，于每月第一个周三19:30—21:00在“中国继续医学教育网”直播。
        </div>
        <div class="picbox animate__animated wow animate__fadeInRight">
          <img src="../../assets/image/Science/jiaoxue/jiaoxue1.webp" alt="" />
        </div>
      </div>
    </div>
    <!-- 项目内容 -->
    <div class="main">
      <div class="title">
        <titleCard title="项目内容"></titleCard>
      </div>
      <p class="titleTxt">规范肾内医疗标准，提升医疗水平，促进优质资源共享</p>
      <div class="contentboxs">
        <div
          class="box animate__animated wow animate__fadeInUp"
          data-wow-duration="1s"
        >
          <img src="../../assets/image/Science/jiaoxue/icon1.webp" alt="" />
          <h3>教学病例</h3>
          <p class="p">核心单位主持分享教学病例、<br />教学查房、领域进展</p>
          <p class="p2">核心单位主持分享教学病例、教学查房、领域进展</p>
        </div>
        <div
          class="box animate__animated wow animate__fadeInUp"
          data-wow-duration="1.2s"
        >
          <img src="../../assets/image/Science/jiaoxue/icon2.webp" alt="" />
          <h3>疑难病例</h3>
          <p class="p">
            下属医联体基层单位<br />
            汇报疑难病例，随访进展
          </p>
          <p class="p2">下属医联体基层单位汇报疑难病例，随访进展</p>
        </div>
        <div
          class="box animate__animated wow animate__fadeInUp"
          data-wow-duration="1.4s"
        >
          <img src="../../assets/image/Science/jiaoxue/icon3.webp" alt="" />
          <h3>点评讨论</h3>
          <p class="p">
            权威专家实时在线<br />
            剖析、点评、讨论
          </p>
          <p class="p2">权威专家实时在线剖析、点评、讨论</p>
        </div>
        <div
          class="box animate__animated wow animate__fadeInUp"
          data-wow-duration="1.6s"
        >
          <img src="../../assets/image/Science/jiaoxue/icon4.webp" alt="" />
          <h3>在线答题</h3>
          <p class="p">学员在线留言 <br />参与提问、答题</p>
          <p class="p2">学员在线留言参与提问、答题</p>
        </div>
        <div
          class="box animate__animated wow animate__fadeInUp"
          data-wow-duration="1.8s"
        >
          <img src="../../assets/image/Science/jiaoxue/icon5.webp" alt="" />
          <h3>病例汇编</h3>
          <p class="p">经典病例汇编成册，<br />正式出版发行</p>
          <p class="p2">经典病例汇编成册，正式出版发行</p>
        </div>
      </div>
    </div>
    <!-- 运营资源 -->
    <div class="footer">
      <div class="title">
        <titleCard title="运营资源"></titleCard>
      </div>
      <div class="content">
        <div class="left animate__animated wow animate__fadeInLeft">
          <img src="../../assets/image/Science/jiaoxue/jiaoxue2.webp" alt="" />
        </div>
        <div class="right animate__animated wow animate__fadeInRight">
          <p class="pd">
            拥有500人医师直播群12个，项目相关信息均可第一 时间发送到医师面前。
          </p>
          <p>
            充分利用本项目的社群优势，点对点接触来自全国各地的肾内医师群体，优化公共关系，丰富人脉网络。
          </p>
        </div>
      </div>
    </div>
    <!-- 往期直播 -->
    <div class="wangqi">
      <div class="title">
        <titleCard title="往期直播"></titleCard>
      </div>
      <div class="boxs animate__animated wow animate__fadeInUp">
        <div class="box" v-for="item in liveList" :key="item.id">
          <div class="play" @click="playVideo(item.id)" v-show="item.isVideo">
            <img src="../../assets/image/Science/jiaoxue/play.png" alt="" />
          </div>
          <div class="picbox">
            <img :src="item.coverImage" alt="" v-if="item.isVideo"/>
            <video width="100%" height="100%" controls ref="video" autoplay="autoplay" style="object-fit: fill" v-else>
              <source :src="item.videoUrl" type="video/mp4">
              <source src="movie.ogg" type="video/ogg">
              您的浏览器不支持Video标签。
            </video>
          </div>
          <div class="txtbox" v-html="item.text"></div>
        </div>
      </div>
      <div class="btn">
        <a href="https://zxsn.ncme.org.cn">查看更多直播<span>></span></a>
      </div>
    </div>
    <footerCard name="吉老师" phone="135-2108-4802"></footerCard>
  </div>
</template>

<script>
import footerCard from "../../components/footer-card.vue";
import titleCard from "../../components/title-card.vue";
export default {
  data() {
    return {
      liveList:[
        {
          id:1,
          isVideo:true,
          videoUrl:"https://yyt-ows.oss-cn-beijing.aliyuncs.com/video/fb6333debb554d85837e5a24928987d0-13bcb1b150ec11cac1e36bbb5dcb0140-ld.mp4",
          coverImage: require("../../assets/image/Science/jiaoxue/zhibo1.webp"),
          text:"天津医科大学第二医院<br />肾内科专家病例分析"
        },
        {
          id:2,
          isVideo:true,
          videoUrl:"https://yyt-ows.oss-cn-beijing.aliyuncs.com/video/5c03707e-18285d5e521.mp4",
          coverImage: require("../../assets/image/Science/jiaoxue/zhibo2.webp"),
          text:"内蒙古科技大学包头医学院<br />第一附属医院病例分析"
        },
        {
          id:3,
          isVideo:true,
          videoUrl:"https://yyt-ows.oss-cn-beijing.aliyuncs.com/video/220a4f9b-18285d5e4b6.mp4",
          coverImage: require("../../assets/image/Science/jiaoxue/zhibo3.webp"),
          text:"上海交通大学医学院附属瑞金<br />医院专家病例分析"
        },
      ]
    };
  },
  components: {
    footerCard,
    titleCard,
  },
  created() {},
  mounted() {},
  methods: {
    playVideo(id){
      this.liveList.forEach(element => {
        element.isVideo = true
      });
      this.liveList = this.liveList.map(item => {
        if (item.id === id) {
          item.isVideo = false
        }
        return item
      })
    }
  },
};
</script>

<style scoped lang="scss">
.jiaoxue {
  .header {
    .title {
      padding: 1rem 0 0.7895rem;
      @media screen and (max-width: 540px) {
        padding: 37px 0 27px 0;
      }
    }
    .head-img {
      height: 2.0842rem;
      background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/9DA5E1080FFA480897983F737F599B2B-6-2.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      margin-bottom: 0.9158rem;
      @media screen and (max-width: 540px) {
        height: 99px;
        // display: block;
        padding: 0 15px;
        position: relative;
      }
      .right {
        width: 4.8947rem;
        height: 1.1895rem;
        @media screen and (max-width: 540px) {
          position: absolute;
          top: 10px;
          right: 15px;
          width: 140px;
          height: 35px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .left {
        width: 8.7368rem;
        margin-left: 2.2947rem;
        @media screen and (max-width: 540px) {
          margin: 0;
          width: 100%;
        }
        h3 {
          color: #0ca6eb;
          font-size: 0.3368rem;
          padding-bottom: 0.3158rem;
          @media screen and (max-width: 540px) {
            font-size: 17px;
            padding-bottom: 20px;
          }
          margin: 0;
        }
        p {
          font-size: 0.2947rem;
          @media screen and (max-width: 540px) {
            font-size: 15px;
          }
          color: #272b2d;
        }
      }
    }
    .content {
      display: flex;
      align-items: center;
      margin-left: 2.2737rem;
      padding-bottom: 1.9474rem;
      @media screen and (max-width: 540px) {
        display: block;
        padding: 0 15px;
        box-sizing: border-box;
        margin: 0;
      }
      .txtbox {
        color: #272b2d;
        font-size: 0.2316rem;
        line-height: 0.4211rem;
        width: 7.1789rem;
        margin-right: 0.9263rem;
        @media screen and (max-width: 540px) {
          font-size: 15px;
          width: 90%;
          line-height: 26px;
          margin: 0 auto;
        }
      }
      .picbox {
        width: 6.8421rem;
        height: 4.2105rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          height: 240px;
          margin-top: 20px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  // 项目内容
  .main {
    .title {
      padding-bottom: 0.4632rem;
      @media screen and (max-width: 540px) {
        padding: 50px 0 28px 0;
      }
    }
    .titleTxt {
      color: #272b2d;
      font-size: 0.2526rem;
      text-align: center;
      padding-bottom: 0.7368rem;
      @media screen and (max-width: 540px) {
        font-size: 15px;
      }
    }
    .contentboxs {
      margin-bottom: 1.4211rem;
      display: flex;
      justify-content: center;
      @media screen and (max-width: 540px) {
        justify-content: center;
        flex-wrap: wrap;
      }
      .box {
        width: 3.2rem;
        height: 4.2105rem;
        position: relative;
        @media screen and (max-width: 540px) {
          height: 162px;
          flex-basis: 122px;
          flex-shrink: 0;
          margin-bottom: 16px;
        }
        background-color: #fbfbfb;
        margin: 0 0.1053rem;
        text-align: center;
        padding-top: 1.0526rem;
        box-sizing: border-box;
        img {
          width: 0.5263rem;
          height: 0.5263rem;
          @media screen and (max-width: 540px) {
            width: 20px;
            height: 20px;
          }
        }
        h3 {
          margin: 0;
          color: #272b2d;
          font-size: 0.2947rem;
          padding: 0.4211rem 0 0.5263rem 0;
          @media screen and (max-width: 540px) {
            padding: 16px 0 20px 0;
            font-size: 13px;
          }
        }
        p {
          color: #333333;
          font-size: 0.2316rem;
          @media screen and (max-width: 540px) {
            font-size: 12px;
          }
        }
        .p {
          @media screen and (max-width: 540px) {
            display: none;
          }
        }
        .p2 {
          display: none;
          padding: 0 5px;
          @media screen and (max-width: 540px) {
            display: block;
          }
        }
      }
      .box::after {
        position: absolute;
        content: "";
        height: 0.0842rem;
        width: 100%;
        background-color: #0ca6eb;
        bottom: 0;
        left: 0;
        @media screen and (max-width: 540px) {
          height: 3px;
        }
      }
    }
  }
  // 运营资源
  .footer {
    background-color: #fbfbfb;
    .title {
      padding: 1rem 0 1.6842rem 0;
      @media screen and (max-width: 540px) {
        padding: 20px 0 40px 0;
      }
    }
    .content {
      display: flex;
      padding-bottom: 1.5368rem;
      align-items: center;
      @media screen and (max-width: 540px) {
        display: block;
        padding: 0 38px;
        box-sizing: border-box;
      }
      .left {
        width: 7.0947rem;
        margin-left: 2.6316rem;
        height: 4.2737rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          margin: 0;
          height: 200px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        padding-left: 1.3053rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          padding: 0;
          padding-top: 40px;
        }
        p {
          color: #666666;
          font-size: 0.2105rem;
          line-height: 0.4211rem;
          width: 4.8421rem;
          @media screen and (max-width: 540px) {
            font-size: 15px;
            color: #272b2d;
            width: 100%;
            line-height: 24px;
          }
        }
        .pd {
          padding-bottom: 0.3158rem;
          @media screen and (max-width: 540px) {
            padding-bottom: 20px;
          }
        }
      }
    }
  }
  // 往期直播
  .wangqi {
    position: relative;
    .title {
      padding: 1.5789rem 0 0.8211rem 0;
    }
    .boxs::-webkit-scrollbar {
      display: none;
    }
    .boxs {
      height: 8.2105rem;
      @media screen and (max-width: 540px) {
        height: 300px;
        padding: 0 10px;
        overflow: scroll;
        overflow-y: hidden;
      }
      box-sizing: border-box;
      padding-bottom: 0.7053rem;
      position: relative;
      padding-top: 0.8421rem;
      background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/21226B9D16854A9AA86DEB5B76DCCF65-6-2.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      @media screen and (max-width: 540px) {
        justify-content: left;
      }
      .box {
        width: 5.0316rem;
        height: 4.7789rem;
        background-color: #fff;
        font-size: 0.2526rem;
        position: relative;
        .play {
          position: absolute;
          left: 50%;
          top: 20%;
          width: 1rem;
          margin-left: -0.5rem;
          height: 1rem;
          border-radius: 50%;
          @media screen and (max-width: 540px) {
            width: 50px;
            height: 50px;
            margin-left: -25px;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
        .play:hover {
          cursor: pointer;
          background-color: #666666;
        }
        @media screen and (max-width: 540px) {
          flex-basis: 240px;
          flex-shrink: 0;
          height: 224px;
        }
        a {
          color: #666666;
          list-style: none;
          display: block;
          background-color: #fff;
        }
        margin: 0 0.2316rem;
        .picbox {
          height: 3.0105rem;

          @media screen and (max-width: 540px) {
            height: 140px;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
        .txtbox {
          @media screen and (max-width: 540px) {
            height: 84px;
            padding-top: 20px;
            box-sizing: border-box;
            line-height: 20px;
            font-size: 15px;
          }
          padding-top: 0.6316rem;
          text-align: center;
          line-height: 0.4rem;
        }
      }

      .box:hover {
        box-shadow: 0px 3px 43px 0px rgba(0, 0, 0, 0.2);
      }
    }
    .btn {
      position: absolute;
      background-color: #0ca6eb;
      bottom: 0.7368rem;
      left: 50%;
      margin-left: -1.2842rem;
      width: 2.5474rem;
      @media screen and (max-width: 540px) {
        width: 120px;
        height: 36px;
        line-height: 36px;
        margin-left: -60px;
        font-size: 14px;
      }
      cursor: pointer;
      a {
        color: #fff;
        list-style: none;
      }
      height: 0.7579rem;
      text-align: center;
      line-height: 0.7579rem;
      color: #fff;
      span {
        padding-left: 0.3368rem;
      }
      font-size: 0.2105rem;
    }
  }
}
</style>
